import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { startLoading, endLoading, startSending, endSending } from "../progress/pogressSlice";
import { serverErrors } from "../";
import { closeModal } from "../modal/modalSlice";
import * as api from '../../api';

const initialState = {
    currentPage: 0,
    events: [],
    rows: 0,
    size: 25,
    status: 'idle'
}

const dir = 'events';

export const fetchEvents = createAsyncThunk('/events/fetch', async(_, thunkAPI) => {
    thunkAPI.dispatch(startLoading());
    try {
        const { data } = await api.getPaginationData(dir);
        thunkAPI.dispatch(endLoading());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue();
    }
})

export const loadNextPage = createAsyncThunk('/events/nextPage', async({page, size}, thunkAPI) => {
    thunkAPI.dispatch(startLoading());
    try {
        const { data } = await api.getPaginationData(dir, page, size);
        thunkAPI.dispatch(endLoading());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue();
    }
})

export const allEvents = createAsyncThunk('/events/fetchAll', async(_, thunkAPI) => {
    thunkAPI.dispatch(startLoading());
    try {
        const { data } = await api.getPaginationData(`${dir}/all`)
        thunkAPI.dispatch(endLoading());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue();
    }
})

export const changePageAllEvents = createAsyncThunk('/events/changePage', async({page, size}, thunkAPI) => {
    thunkAPI.dispatch(startLoading());
    try {
        const { data } = await api.getPaginationData(`${dir}/all`, page, size);
        thunkAPI.dispatch(endLoading());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue();
    }
})

export const eventDetails = async(id, dispatch, setData, setStatus) => {
    dispatch(startLoading());
    try {
        const { data } = await api.getData(`${dir}/details/${id}`);
        dispatch(endLoading());
        setStatus('succeeded');
        return setData(data)
    } catch (error) {
        console.log(error);
        return dispatch(serverErrors(error, endLoading))
    }
}

export const createEvent = createAsyncThunk('/events/create', async({ values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.createNew(dir, values);
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue();
    }
})

export const editEvent = createAsyncThunk('/events/edit', async({ id, values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.editData(dir, id, values);
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue();
    }
})

export const changeState = createAsyncThunk('/events/changeSate', async({ id, state }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        await api.editData(`${dir}/state`, id, { state })
        thunkAPI.dispatch(endSending());
        return { id, isActive: state };
    } catch (error) {
        console.log(error);      
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue()
    }
})

export const changeStateConstacy = createAsyncThunk('/events/stateConstancy', async({ id, state }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        await api.editData(`${dir}/constancies`, id, { state })
        thunkAPI.dispatch(endSending());
        return { id, constancy: state };
    } catch (error) {
        console.log(error);      
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue()
    }
})

export const deleteEvent = createAsyncThunk('/events/delete', async({ id }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        await api.deleteItem(dir, id);
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal())
        return id;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue();
    }
})

export const eventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        clearEvents: (state) => initialState
    },
    extraReducers(builder){
        builder
            .addCase(createEvent.fulfilled, (state, action) => {
                state.rows = state.rows + 1;
                state.events = [action.payload, ...state.events]
            })
            .addCase(editEvent.fulfilled, (state, action) => {
                Object.keys(state.events).forEach(function eachKey(key){
                    if(state.events[key].id === action.payload.id)
                        return state.events[key] = action.payload
                })
            })
            .addCase(changeState.fulfilled, (state, action) => {
                Object.keys(state.events).forEach(function eachKey(key){
                    if(state.events[key].id === action.payload.id)
                        return state.events[key].isActive = action.payload.isActive
                })
            })
            .addCase(changeStateConstacy.fulfilled, (state, action) => {
                Object.keys(state.events).forEach(function eachKey(key){
                    if(state.events[key].id === action.payload.id)
                        return state.events[key].constancy = action.payload.constancy
                })
            })
            .addCase(deleteEvent.fulfilled, (state, action) => {
                state.rows = state.rows - 1;
                state.events = state.events.filter(el => el.id !== action.payload);
            })
            .addMatcher(isAnyOf(loadNextPage.fulfilled, changePageAllEvents.fulfilled), (state, action) => {
                const { currentPage, events, size } = action.payload;
                state.currentPage = currentPage
                state.events = events
                state.size = size
            })
            .addMatcher(isAnyOf(fetchEvents.fulfilled, allEvents.fulfilled), (state, action) => {
                const { currentPage, events, size, total } = action.payload;
                state.currentPage = currentPage
                state.events = events
                state.rows = total
                state.size = size
                state.status = 'succeeded'
            })
    }
})

export const { clearEvents } = eventsSlice.actions;

export default eventsSlice.reducer;